import {CommandBase} from "./CommandBase";
import {CommandManager} from "../libs/CommandManager";
import {Asset} from "../entities/Asset";

export class CommandAccelSensorDirective extends CommandBase implements ng.IDirective {
    restrict= 'AEC';
    transclude = false;
    template = require('../../views/cmdaccelsensor.html').default;
    scope = {
        selectedItems : "=",
        commandEnabled : "="
    };
    accelSensorEnabled:boolean = true;
    constructor(commandManager:CommandManager) {
        super(commandManager);
    }
    controller = ['$scope',($scope:any)=>{
        $scope.vm = this;
        $scope.$watch(()=>$scope.selectedItems.length, (newVal:any)=> {
            this.selectedItems = $scope.selectedItems;
        });
    }]
    getCommandText(asset:Asset):string{
        var sensorText:string = this.accelSensorEnabled ? "true" : "false";
        return asset.vTagID + ":" + sensorText;
    }
    getCommandType():string{
        return "Accel Sensor";
    }
    static factory():ng.IDirectiveFactory {
        var directive = (commandManager:CommandManager) => {
            return new CommandAccelSensorDirective(commandManager);
        }
        directive.$inject = ['CommandManager'];
        return directive;
    }
}
